import i18n from 'i18next'
import LanguageDetector from 'i18next-browser-languagedetector'
import { initReactI18next } from 'react-i18next'

import deTranslation from './locales/de/translation.json' // German
import enTranslation from './locales/en/translation.json' // English
import esTranslation from './locales/es/translation.json' // Spanish
import plTranslation from './locales/pl/translation.json' // Polish

// the translations
// (tip move them in a JSON file and import them,
// or even better, manage them separated from your code: https://react.i18next.com/guides/multiple-translation-files)
const resources = {
  de: {
    translation: deTranslation,
  },
  en: {
    translation: enTranslation,
  },
  es: {
    translation: esTranslation,
  },
  pl: {
    translation: plTranslation,
  },
}

i18n
  .use(LanguageDetector)
  .use(initReactI18next) // passes i18n down to react-i18next
  .init({
    fallbackLng: {
      de: ['de', 'en'],
      default: ['en'],
      es: ['es', 'en'],
      pl: ['pl', 'en'],
    },
    interpolation: {
      escapeValue: false, // react already safes from xss
    },
    resources,
  })

export const { t } = i18n
export default i18n
